import React from "react";

const DraggableItem = ({
  index,
  content,
  moduleId,
  componentId,
  isUsed, // true if content already used / disabled (e.g. no symbol on related claim)
  hideIfUsed, // "Not used in editor" ON: remove row from DOM when placed on canvas
  /** When set, hideIfUsed uses this instead of isUsed (e.g. related claim: isUsed includes "no symbol") */
  isPlacedOnEditor,
  dragMatch, // your drag function
  onDragEndUpdate, // callback for drag end
  sixDotIcon,
  type = "default", // optional: "ref" for references
  relatedClaimComp,
}) => {
  const contentId = `${moduleId}-${componentId}`;

  const placedForFilter =
    isPlacedOnEditor !== undefined ? isPlacedOnEditor : isUsed;

  if (hideIfUsed && placedForFilter) {
    return null;
  }

  /** Block drag/gray when deck/canvas says placed (isPlacedOnEditor catches canvas before isUsed sync). */
  const blockDrag = isUsed || isPlacedOnEditor === true;

  const handleDragStart = (e) => {
    if (blockDrag) return;
    // Ghost image to prevent prohibited cursor
    const ghost = document.createElement("div");
    ghost.style.width = "1px";
    ghost.style.height = "1px";
    ghost.style.position = "absolute";
    ghost.style.top = "-1000px";
    document.body.appendChild(ghost);
    e.dataTransfer.setDragImage(ghost, 0, 0);
    setTimeout(() => document.body.removeChild(ghost), 0);

    if (blockDrag) {
      e.preventDefault();
      return;
    }

    e.dataTransfer.setData("text/plain", contentId);
    e.dataTransfer.effectAllowed = "move";

    dragMatch(e, (type = "ref")); // "ref" or default
  };

  return (
    <div
      className={`draggableText ${
        blockDrag ? "grayOut" : ""
      } d-flex showContent_OnEditor`}
      draggable={!blockDrag}
      onDragStart={handleDragStart}
      onDragEnd={onDragEndUpdate}
      onDragOver={(e) => e.preventDefault()}
    >
      {sixDotIcon && (
        <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
      )}
      <div className={`textvariant d-flex ${type === "ref"?'align-items-start':'align-items-center'}`}>
        {type === "ref" && <span className="me-1">{index + 1} </span>}
        <div
          module-claim={moduleId}
          related-claim-comp={relatedClaimComp ? relatedClaimComp : ""}
          className="parent-claim alignText"
          data-content-id={contentId}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

export default DraggableItem;
